export const SESSION_STORAGE_KEYS = {
  IMPERSONATION_USER: 'impersonationUser',
  MFA_CHALLENGE: 'mfaChallenge',
};
